import React, { useState } from 'react';
import { Menu, Row, Col } from 'antd';
import type { MenuProps } from 'antd';
import { FileTextOutlined } from '@ant-design/icons';
import styles from './index.module.css';
import Rule1 from './Rule1';
import Rule2 from './Rule2';

// 主组件
const App: React.FC = () => {
    const [selectedRule, setSelectedRule] = useState<string>('2');

    const menuItems: MenuProps['items'] = [
        {
            key: '1',
            icon: <FileTextOutlined />,
            label: '第一届灼灼杯开赛公告',
        },
        {
            key: '2',
            icon: <FileTextOutlined />,
            label: '第二届灼灼杯开赛公告',
        },
    ];

    const handleMenuSelect: MenuProps['onSelect'] = ({ key }) => {
        setSelectedRule(key);
    };

    const renderRuleContent = () => {
        switch (selectedRule) {
            case '1':
                return <Rule1 />;
            case '2':
                return <Rule2 />;
            default:
                return <Rule2 />;
        }
    };

    return (
        <div className={styles.competitionContainer}>
            <Row gutter={24} className={styles.layoutRow}>
                {/* 左侧菜单（桌面端） */}
                <Col xs={0} sm={8} md={6} lg={5} xl={4}>
                    <div className={styles.menuContainer}>
                        <Menu
                            mode="inline"
                            selectedKeys={[selectedRule]}
                            items={menuItems}
                            onSelect={handleMenuSelect}
                            className={styles.sideMenu}
                        />
                    </div>
                </Col>

                {/* 顶部菜单（移动端） */}
                <Col xs={24} sm={0}>
                    <div className={styles.topMenuContainer}>
                        <Menu
                            mode="horizontal"
                            selectedKeys={[selectedRule]}
                            items={menuItems}
                            onSelect={handleMenuSelect}
                            className={styles.topMenu}
                        />
                    </div>
                </Col>

                {/* 右侧内容 */}
                <Col xs={24} sm={16} md={18} lg={19} xl={20}>
                    <div className={styles.contentContainer}>
                        {renderRuleContent()}
                    </div>
                </Col>
            </Row>
        </div>
    );
};

export default App;
